module.exports = __webpack_public_path__ + "img/spacio.c621af64.jpg";